import { BaseDataObject } from "./BaseDataObject";

export class TeamDataObject extends BaseDataObject {
    teamName?: string;
}
